// 📁 ConfirmDeleteModal.js
import React, { useState } from "react";
import { Modal, Button, Spinner } from "react-bootstrap";
import axios from "../../context/AxiosInstance";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
const MySwal = withReactContent(Swal);

const ConfirmDeleteModal = ({ show, handleClose, selectedItem, token, refreshData }) => {
  const [loading, setLoading] = useState(false);

  const handleConfirmDelete = async () => {
    if (!selectedItem || !selectedItem.id_crg) {
      Swal.fire("Erreur", "Aucun élément sélectionné", "error");
      return;
    }

    setLoading(true);
    try {
      await axios.patch(
        `/crg/${selectedItem.id_crg}/disable`,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      Swal.fire("Supprimé 🗑", "", "success");
      refreshData();
      handleClose();
    } catch (err) { 
      const msg = err.response?.data?.detail?.message || err.response?.data?.detail || "Un salaire est deja lié à ce crg donc il ne peut pas etre supprimé";
      MySwal.fire("Erreur ❌", msg, "error");
      //Swal.fire("Erreur ❌", msg, "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={handleClose} centered backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>Confirmation</Modal.Title>
      </Modal.Header>
      <Modal.Body>Voulez-vous Supprimer cet élément ?</Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose} disabled={loading}>
          Annuler
        </Button>
        <Button variant="danger" onClick={handleConfirmDelete} disabled={loading}>
          {loading ? <Spinner animation="border" size="sm" /> : "Supprimer"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmDeleteModal;
